import { configureStore } from '@reduxjs/toolkit';
import { ACCOUNT_STORE_NAME, createAccountStore, defaultAccountStore } from '@cmctechnology/webinvest-store-accounts';
import { CHARTS_STORE_NAME, createChartsStore, defaultChartsStore } from '@cmctechnology/webinvest-store-charts';
import { CLIENT_STORE_NAME, createClientStore, defaultClientStore } from '@cmctechnology/webinvest-store-client';
import { EXCHANGE_STORE_NAME, createExchangeStore, defaultExchangeStore } from '@cmctechnology/webinvest-store-exchange';
import { FRONTEND_STORE_NAME, createFrontendStore, defaultFrontendStore } from '@cmctechnology/webinvest-store-frontend';
import { INSTRUMENT_STORE_NAME, createInstrumentStore, defaultInstrumentStore } from '@cmctechnology/webinvest-store-instruments';
import { MARKET_DATA_STORE_NAME, createMarketDataStore, defaultMarketDataStore } from '@cmctechnology/webinvest-store-marketdata';
import { WATCHLISTS_STORE_NAME, createWatchlistsStore, defaultWatchlistsStore } from '@cmctechnology/webinvest-store-watchlists';
import { createMessagesStore, defaultMessagesStore, MESSAGES_STORE_NAME } from '@cmctechnology/webinvest-store-messages';
import { ORDERS_STORE_NAME, createOrdersStore, defaultOrdersStore } from '@cmctechnology/webinvest-store-orders';
import { SUBSCRIPTIONS_STORE_NAME, createSubscriptionsStore, defaultSubscriptionsStore } from '@cmctechnology/webinvest-store-subscriptions';

import {
  MARKETDATA_WS_STORE_NAME,
  createMarketDataWsStore,
  defaultMarketDataWsStore,
  marketDataWsMiddleware
} from '@cmctechnology/webinvest-api-client-market-data-ws';
import { APP_STAGE, AppStage } from '@cmctechnology/webinvest-constants';

export const store = configureStore({
  reducer: {
    [ACCOUNT_STORE_NAME]: createAccountStore(defaultAccountStore).reducer,
    [CHARTS_STORE_NAME]: createChartsStore(defaultChartsStore).reducer,
    [CLIENT_STORE_NAME]: createClientStore(defaultClientStore).reducer,
    [EXCHANGE_STORE_NAME]: createExchangeStore(defaultExchangeStore).reducer,
    [FRONTEND_STORE_NAME]: createFrontendStore(defaultFrontendStore).reducer,
    [INSTRUMENT_STORE_NAME]: createInstrumentStore(defaultInstrumentStore).reducer,
    [MARKET_DATA_STORE_NAME]: createMarketDataStore(defaultMarketDataStore).reducer,
    [MESSAGES_STORE_NAME]: createMessagesStore(defaultMessagesStore).reducer,
    [ORDERS_STORE_NAME]: createOrdersStore(defaultOrdersStore).reducer,
    [MARKETDATA_WS_STORE_NAME]: createMarketDataWsStore(defaultMarketDataWsStore).reducer,
    [WATCHLISTS_STORE_NAME]: createWatchlistsStore(defaultWatchlistsStore).reducer,
    [SUBSCRIPTIONS_STORE_NAME]: createSubscriptionsStore(defaultSubscriptionsStore).reducer
  },
  middleware: (getDefaulMiddleware) =>
    // eslint-disable-next-line unicorn/prefer-spread
    getDefaulMiddleware().concat(marketDataWsMiddleware({ debug: (process.env.REACT_APP_STAGE as AppStage) !== APP_STAGE.Prod }))
});

export type IStore = ReturnType<typeof store.getState>;
